import { render } from "./SignatureField.vue?vue&type=template&id=26afc9e0"
import script from "./SignatureField.vue?vue&type=script&lang=js"
export * from "./SignatureField.vue?vue&type=script&lang=js"
script.render = render

export default script